module.exports = __webpack_public_path__ + "static/media/hartnell.74c8fb29.jpg";